const ORDER_STATUS = {
  READY_FOR_PICKUP: "60217fe883c214ff80da27aa",
  COMPLETED: "5eb509ef3390527550d48e19",
  PENDING: "5eb509e93390527550d48e18",
  CANCELLED: "5eb509f73390527550d48e1a",
  PENDING_APPROVAL: "5eb509fe3390527550d48e1b",
};

const DELIVERY_STATUS = {
  PENDING: "5ebb95ebb141ce6ffe2b82b6",
  ON_ROAD: "5ebb95f2b141ce6ffe2b82b7",
  DELIVERED: "5ebb95f9b141ce6ffe2b82b8",
};

const KOT_STATUS = {
  PENDING: "PENDING",
  DELIVERED: "ENTREGADA",
};

const USER_ID = "5e9bfa0660adbac3ca166b46";

export { ORDER_STATUS, DELIVERY_STATUS, KOT_STATUS, USER_ID };
export default ORDER_STATUS;
